import videojs from "video.js";

const Plugin = videojs.getPlugin("plugin");

class Hotkeys extends Plugin {
    constructor(player, options) {
        super(player, options);
        this.player = player;
        this.options = options;

        this.setupHotkeys();
    }

    setupHotkeys() {
        const player = this.player;

        player.ready(() => {
            document.addEventListener("keydown", this.keydown.bind(this));
        });
    }

    keydown(event) {
        const seekStep = this.options.seekStep;
        const now = this.player.currentTime();

        if (this.isRewindKey(event)) {
            this.player.currentTime(Math.max(0, now - seekStep));
        }

        if (this.isForwardKey(event)) {
            let duration = this.player.duration();
            if (this.player.liveTracker && this.player.liveTracker.isLive()) {
                duration = this.player.liveTracker.seekableEnd();
            }
            this.player.currentTime(Math.min(now + seekStep, duration));
        }

    }

    isRewindKey(e) {
        return (e.which === 37 || e.which === 177);
    }

    isForwardKey(e) {
        return (e.which === 39 || e.which === 176);
    }
}

videojs.registerPlugin("hotkeys", Hotkeys);